<template lang="pug">
  tr
    td.no-wrap(
      v-for="(_, pos) of headers"
      :class="{ pinned: headers[pos].pinned }" 
    ) 
      div(v-html="getValue(pos, item)")
</template>

<script>
import DataTableMenu from '@/Core/components/DataTableMenu';
import { TEAM_MEMBER } from '@/Reporting/config/constants';

export default {
  components: {
    DataTableMenu,
  },
  props: {
    data: {
      type: Object,
      default: {},
    },
    headers: {
      type: Array,
      default: [],
    },
    includeComparedPercentage: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    item() {
      if (this.data.item) {
        return this.data.item;
      }
    },
  },
  methods: {
    getValue(pos, item) {
      const h = this.headers[pos];
      if (h.value === TEAM_MEMBER) {
        const teamMember = item.events.find(evt => Object.keys(evt)[0] === TEAM_MEMBER);
        return teamMember[h.value].name;
      }

      const count = `<span class="item-count">${item.events[pos][h.value].count}</span>`;
      if (!this.includeComparedPercentage) {
        return count;
      }

      const percentage = item.events[pos][h.value].percentage_comparison;
      const percClass = () => {
        if (percentage > 0) {
          return 'item-percentage--positive';
        } else if (percentage < 0) {
          return 'item-percentage--negative';
        }
      };

      return `${count}<span class="item-percentage ${percClass()}">${percentage}%</span>`;
    },
  },
};
</script>

<style lang="scss">
.pinned {
  position: sticky; /* pinned columns */
  z-index: 1;
  background-color: #fff;
}
td.pinned:nth-of-type(2) {
  left: 250px !important; /* first column position */
}
.item-count {
  font-size: 14px;
}
.item-percentage {
  font-size: 12px;
  margin-left: 12px;
  &--positive {
    color: var(--v-success-darken2);
  }
  &--negative {
    color: var(--v-error-darken2);
  }
}
</style>
